export default __webpack_public_path__ + "static/media/514.5790c419.gif";